<header>
  <div class="media">
    <img src={{imgPath}}>
    <span>{{title}}</span>
  </div>
</header>
